import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
// Add your imports here
import HomepageLeoClubDigitalHub from "pages/homepage-leo-club-digital-hub";
import AboutHeritageVision from "pages/about-heritage-vision";
import ImpactMetricsStories from "pages/impact-metrics-stories";
import JoinMembershipGateway from "pages/join-membership-gateway";
import ContactConnectionCenter from "pages/contact-connection-center";
import MembersLeadershipShowcase from "pages/members-leadership-showcase";
import NotFound from "pages/NotFound";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your routes here */}
        <Route path="/" element={<HomepageLeoClubDigitalHub />} />
        <Route path="/home" element={<HomepageLeoClubDigitalHub />} />
        <Route path="/about" element={<AboutHeritageVision />} />
        <Route path="/impacts" element={<ImpactMetricsStories />} />
        <Route path="/join" element={<JoinMembershipGateway />} />
        <Route path="/contact" element={<ContactConnectionCenter />} />
        <Route path="/members" element={<MembersLeadershipShowcase />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;